import {useEffect} from 'react';

import {useCustomerApiCurrent} from 'api/magento/customer/customer';
import {useHostDispatch, useHostSelector} from 'hooks/hostHooks/hostHooks';
import {CustomerType} from 'hostApplicationStoreType';
import {getCustomer} from 'selectors/customer';

/**
 * Custom hook to update
 */
export const useGetCustomerData = () => {
    const customer = useHostSelector(getCustomer);
    const hostDispatch = useHostDispatch();
    const {data, error, isError} = useCustomerApiCurrent({
        query: {
            enabled: (customer.status || '').toLowerCase() !== 'fulfilled',
            refetchOnWindowFocus: false,
            select: response => ({...response, status: 'fulfilled'}),
        },
    });

    useEffect(() => {
        if (data)
            hostDispatch({
                payload: {data},
                type:
                    __BUILD_TYPE__ === 'desktop'
                        ? 'GET_CUSTOMER_DATA_FULFILLED'
                        : 'CUSTOMER@GET_CUSTOMER_DATA_FULFILLED',
            });
    }, [data, hostDispatch]);

    useEffect(() => {
        if (isError)
            hostDispatch({
                payload: error,
                type:
                    __BUILD_TYPE__ === 'desktop'
                        ? 'GET_CUSTOMER_DATA_REJECTED'
                        : 'CUSTOMER@GET_CUSTOMER_DATA_REJECTED',
            });
    }, [isError, error, hostDispatch]);

    if (isError) return customer;
    if ((customer.status || '').toLowerCase() === 'fulfilled') return customer;
    return (data || customer) as CustomerType;
};

/**
 * returns customer email
 */
export const useGetCustomerEmail = () => {
    const {email} = useGetCustomerData();

    return email;
};

/**
 * returns customer fullName
 */
export const useGetCustomerFullName = () => {
    const {firstname, lastname} = useGetCustomerData();

    return firstname && lastname ? `${firstname} ${lastname}`.trim() : '';
};
